module.exports = __webpack_public_path__ + "img/0Q3A2198_L_BlackMatted_MockedUp.3b1ee9c5.jpg";